import React, { useEffect } from 'react';

import * as copy from 'src/components/organisms/NoSearchResultsGuard/constants/copy';
import * as styles from 'src/components/organisms/NoSearchResultsGuard/styles';

interface NoSearchResultsGuardProps {
  children: React.ReactNode;
  onMessageVisible: VoidFunction;
  searchTerm: string;
  showNoSearchResultsMessage: boolean;
}

export const NoSearchResultsGuard = ({
  children,
  onMessageVisible,
  searchTerm,
  showNoSearchResultsMessage,
}: NoSearchResultsGuardProps) => {
  useEffect(() => {
    if (showNoSearchResultsMessage) {
      onMessageVisible();
    }
  }, [showNoSearchResultsMessage, onMessageVisible]);

  return showNoSearchResultsMessage ? (
    <div css={styles.noSearchResultsWrapper}>
      <h1 css={styles.heading}>
        <span css={styles.headingText}>{copy.HEADING}</span>
        <span css={styles.headingTerm}>&quot;{searchTerm}&quot;</span>
      </h1>
      <p css={styles.info}>{copy.TRY_AGAIN_INFO}</p>
    </div>
  ) : (
    <>{children}</>
  );
};
